// Diese Funktion versteckt alle Absätze außer dem ersten in der Rich-Text-Sektion
// und fügt einen "mehr anzeigen" Button hinzu, der die versteckten Absätze
// anzeigt, wenn er geklickt wird.
// Diese Funktion wird nur auf mobilen Geräten (max. 768px Breite) ausgeführt
document.addEventListener('DOMContentLoaded', function() {
    if (window.innerWidth <= 768) { // Nur für mobile Geräte
      const richText = document.querySelector('.template-index .section-richtext .rich-text__text');
      if (!richText) return;
      const paragraphs = richText.querySelectorAll('p');
      if (paragraphs.length > 1) {
        let hiddenContent = '';
        for (let i = 1; i < paragraphs.length; i++) {
          hiddenContent += paragraphs[i].outerHTML;
          paragraphs[i].style.display = 'none';
        }
        
        const showMoreButton = document.createElement('span');
        showMoreButton.textContent = 'mehr anzeigen';
        showMoreButton.style.color = '#E2001A';
        showMoreButton.style.cursor = 'pointer';
        richText.appendChild(showMoreButton);

        showMoreButton.addEventListener('click', function() {
          const isHidden = paragraphs[1].style.display === 'none';
          for (let i = 1; i < paragraphs.length; i++) {
            paragraphs[i].style.display = isHidden ? 'block' : 'none';
          }
          showMoreButton.textContent = isHidden ? 'weniger anzeigen' : 'mehr anzeigen';
        });
      }
    }
  });



// fügt CSS-Stile zum Shadow DOM des `hitsy-container` hinzu (Cart Progress Bar)
const targetSelector = 'hitsy-container';
const cssToInject = `


@media (max-width: 768px) {
  .hitsy-card{
  // padding: 10px 3rem 10px 2rem !important;
  transform: translateY(-2rem) !important;
  } 
  
}

.hitsy-progress-background {
    height: 32px !important;
}
  .hitsy-progress-icon {
    height: 34px!important;
    width: 34px!important;
    padding: 2px!important;
  }
`;

function injectStyleIntoShadow(shadowRoot, css) {
  // console.log('[ShadowCSS] Style wird in Shadow DOM eingefügt.');
  const style = document.createElement('style');
  style.textContent = css;
  shadowRoot.appendChild(style);
  // console.log('[ShadowCSS] Style erfolgreich injiziert.');
}

function waitForShadowRootAndInject() {
  const target = document.querySelector(targetSelector);
  if (!target) {
    // console.warn(`[ShadowCSS] Element ${targetSelector} nicht gefunden.`);
    return;
  }

  // console.log(`[ShadowCSS] Element ${targetSelector} gefunden.`);

  let observer;

  const tryInject = () => {
    if (target.shadowRoot) {
      // console.log('[ShadowCSS] shadowRoot entdeckt, versuche CSS zu injizieren...');
      injectStyleIntoShadow(target.shadowRoot, cssToInject);
      // if (observer) observer.disconnect();
      // console.log('[ShadowCSS] Observer für shadowRoot gestoppt.');
    } else {
      console.log('[ShadowCSS] shadowRoot noch nicht vorhanden.');
    }
  };

  tryInject();

  observer = new MutationObserver(() => {
    // console.log('[ShadowCSS] Mutation erkannt, versuche erneut zu injizieren...');
    tryInject();
  });

  observer.observe(target, { childList: true, subtree: true });
  // console.log('[ShadowCSS] Observer für shadowRoot gestartet.');
}

const waitForElement = new MutationObserver(() => {
  const el = document.querySelector(targetSelector);
  if (el) {
    // console.log(`[ShadowCSS] ${targetSelector} ist im DOM erschienen.`);
    waitForShadowRootAndInject();
    // waitForElement.disconnect();
    // console.log('[ShadowCSS] Observer für DOM gestoppt.');
  }
});

waitForElement.observe(document.body, { childList: true, subtree: true });
// console.log('[ShadowCSS] Observer für DOM gestartet.');
